<!-- =========================================================================================
    File Name: FeatherIcon.vue
    Description: Feather icon component. Creates feather icon based on 'icon' prop
    Component Name: FeatherIcon
    ----------------------------------------------------------------------------------------


========================================================================================== -->

<script>
import * as icons from 'vue-feather-icons'

export default {
  functional:true,
  name: 'feather-icon',
  props: {
    icon: { required: true },
    svgClasses: { type: [String, Object, Array], default: '' },
    badge: {}
  },
  render (h, {props, data}) {
    data.staticClass = `${data.staticClass || ''} feather-icon select-none relative`.trim()
    const svg = h(icons[props.icon], {class: props.svgClasses})
    let badgeEl = ''
    if (props.badge === -1) {
      badgeEl = h('span', {class: 'feather-icon-badge bg-danger text-white h-3 w-3 absolute rounded-full text-xs flex items-center justify-center', style: 'top: -7px; right: -5px'}, [])
    } else {
      badgeEl = h('span', {class: 'feather-icon-badge bg-danger text-white h-5 w-5 absolute rounded-full text-xs flex items-center justify-center', style: 'top: -7px; right: -5px'}, [props.badge])
    }
    const children = [svg]
    if (props.badge) children.push(badgeEl)
    return h('span', data, children)
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/featherIcon.scss"
</style>
